export function formatInstant(isoUtc: string): string {
    return new Date(isoUtc).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit'
    });
}

// Formats a shift time (UTC ISO string from KMP) in the location's timezone.
// KMP delivers BrowserShift.startTime/endTime as kotlinx.datetime.Instant.toString()
// (UTC with Z suffix). The location timezone must be passed explicitly so the display
// matches the schedule the manager created — not the device's local timezone.
export function formatLocalTime(isoUtc: string, timezone: string): string {
    return new Date(isoUtc).toLocaleTimeString([], {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: timezone
    });
}

export function elapsedSince(startIso: string, nowIso: string): string {
    const ms = new Date(nowIso).getTime() - new Date(startIso).getTime();
    const totalMinutes = Math.max(0, Math.floor(ms / 60000));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours > 0) return `${hours}h ${String(minutes).padStart(2, '0')}m`;
    return `${minutes}m`;
}

export function formatDuration(startIso: string, endIso: string): string {
    const ms = new Date(endIso).getTime() - new Date(startIso).getTime();
    const totalMinutes = Math.max(0, Math.round(ms / 60000));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours > 0) return `${hours}h ${minutes}m`;
    return `${minutes}m`;
}
